module.exports = __webpack_public_path__ + "img/NCB_xiwen_2021.7d5fe707.jpg";